import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { Derogation } from '@classes/derogation/derogation';
import { FormatService } from '@services/format.service';
import { DerogationService } from '@services/derogation.service';
import { SimulationService } from '@services/simulation.service';
import { UiService } from '@services/ui.service';

@Component({
    selector: 'app-edit-form',
    templateUrl: './edit-form.component.html',
    styleUrls: ['./edit-form.component.scss']
})
export class EditFormComponent implements OnInit, OnDestroy {
    private loadingSub: Subscription;

    @Input() derogations: Derogation[];

    isLoading: boolean;
    isReadonly: boolean;
    isMJP: boolean;

    constructor(
        private formatSrv: FormatService,
        private derogationSrv: DerogationService,
        private simuSrv: SimulationService,
        private uiSrv: UiService,
        private router: Router
    ) { }

    ngOnInit() {
        this.isReadonly = this.derogations.every(d => d.isReadonly);
        this.isMJP      = this.simuSrv.localSimu.isMJP;
        this.initSubscriptions();
    }

    parseValue(inputValue: string): number {
        return this.formatSrv.stringToFloat(inputValue);
    }

    onSubmit(): void {
        this.isLoading = true;
        this.derogationSrv.post(this.derogations)
        .subscribe(() => {
            this.isLoading = false;
            // Get latest simulation with derogations applied
            this.simuSrv.get()
            .subscribe(() => {
                this.router.navigate(['/simulation/live']);
            });
        });
    }

    onReset(): void {
        this.isLoading = true;
        this.derogationSrv.reset()
        .subscribe(() => {
            this.simuSrv.get()
            .subscribe(() => {
                this.isLoading = false;
                this.router.navigate(['/simulation/live']);
            });
        });
    }

    private initSubscriptions(): void {
        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
